import React from 'react';
import classNames from 'classnames';
import { useIntl } from '../../util/reactIntl';
import css from './TransactionModelBadge.module.css';

// category_config_versions.transaction_model. Anything outside this set is
// treated as unknown and renders nothing, so adding a model admin-side can't
// put a raw enum value like "milestone" in front of a customer.
export const KNOWN_MODELS = ['fixed', 'hourly', 'negotiated'];

/**
 * Small pill on a listing card / listing page showing how the service is
 * transacted — "Fixed price", "Hourly", "Get a quote".
 *
 * The value comes from the category's *currently active* config, resolved at
 * render time from useCategoryConfigMap. It is intentionally not stored on the
 * listing or the Algolia record: config is admin-owned and versioned, so an
 * admin edit has to take effect on next read rather than needing every listing
 * rewritten. Bookings pin their own version separately (ledger_entries).
 *
 * Renders null when the config can't be resolved. That is the normal case for
 * listings still on the legacy numeric taxonomy, which map to no DB category —
 * an absent badge reads as intentional, a placeholder reads as broken.
 */
const TransactionModelBadge = props => {
  const { config, className } = props;
  const intl = useIntl();

  const model = config?.transactionModel;
  if (!model || !KNOWN_MODELS.includes(model)) return null;

  // One colour for all three models for now (marketplace yellow). The model is
  // still in `model` if per-model tinting is wanted later — add
  // `css[model]` back here plus the matching classes in the stylesheet.
  return (
    <span className={classNames(css.badge, className)}>
      {intl.formatMessage({ id: 'ListingCard.transactionModelBadge' }, { model })}
    </span>
  );
};

export default TransactionModelBadge;
